/* ==========================================================================
   ODYSSÉE ACADEMY, popups globales (.booking-popup), site-wide.

   a) Moteur générique data-booking / data-booking-popup : ouverture/fermeture,
      focus piégé (Tab/Shift+Tab), Échap, clic sur croix/voile, verrou de
      scroll (classe html.booking-popup-open, 100% CSS, pas de manipulation
      d'overflow ici). Verbatim SPEC-BLOG-POPUPS-MEGAMENUS.md §Partie 3.5.a ,
      duplication locale du piège de focus plutôt que d'aller chercher
      trapTab() dans assets/product.js (scopé à la seule page produit) :
      acceptée explicitement par la spec (§6).
      05/09 (LOT RESPONSIVE B) : open() referme aussi le tiroir mobile
      (#nav-menu) s'il est ouvert -- son z-index (10010, même famille que
      le tiroir panier) dépasse celui de TOUTE popup générique (10000,
      cf. sections/global-popups.liquid), qui s'ouvrait donc invisible,
      cachée derrière le tiroir encore affiché. Concerne « Réserver un
      essai », remonté en haut du tiroir (sections/header.liquid) mais
      aussi n'importe quel autre data-booking à l'intérieur : assets/
      theme.js ne referme le tiroir que sur clic d'un .nav-link/.nav-
      sublink, jamais sur un .main-button, corrigé ici, dans le moteur
      partagé, plutôt que dans theme.js (hors périmètre fichier de ce lot),
      pour que ça profite à tout déclencheur, pas seulement à celui-ci.
   b) Popup "film" : lecture/pause synchronisée à l'ouverture (MutationObserver
      sur la classe is-open, rejoue depuis 0 à chaque fermeture).
   c) Popup "teaser" : identique à (b) mais FORCE le son (le teaser doit être
      sonore dès l'ouverture, contrairement au film qui n'a jamais eu l'attribut
      muted).
   d) Popup "localisation" : carte Leaflet, chargée en PARESSEUX à la première
      ouverture, mais AUTO-HÉBERGÉE (assets/leaflet.min.js + .min.css déjà
      dans le thème), jamais unpkg.com comme la version Webflow d'origine.
      Les URLs d'asset et les coordonnées sont lues sur .nav-map via des
      data-attributes posés par sections/global-popups.liquid (Liquid seul
      connaît asset_url).

   05/09 (REPRISE LOT D2 BIS) : ancien point e), popup "sportigo" (widget
      BuyFromList dédié à la carte vedette de home-events.liquid), RETIRÉ
      avec la popup elle-même (sections/global-popups.liquid) : plus aucun
      déclencheur data-booking="sportigo" dans le thème, section morte
      supprimée ci-dessous plutôt que laissée orpheline (elle ne se serait
      plus jamais montée, aucun `[data-booking-popup="sportigo"]` à trouver).
   ========================================================================== */
(function () {
  'use strict';

  /* --- a) Moteur générique ouverture/fermeture --------------------------- */

  document.addEventListener('DOMContentLoaded', function () {
    var openPopup = null, lastFocus = null;
    var FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),iframe,[tabindex]:not([tabindex="-1"])';

    function findPopup(id) { return id ? document.querySelector('[data-booking-popup="' + id + '"]') : null; }

    function focusables(p) {
      return [].slice.call(p.querySelectorAll(FOCUSABLE)).filter(function (el) {
        return el.offsetParent !== null || el === document.activeElement;
      });
    }

    function closeMobileDrawerIfOpen() {
      var navMenu = document.getElementById('nav-menu');
      if (!navMenu || !navMenu.classList.contains('is-open')) return;
      navMenu.classList.remove('is-open');
      document.documentElement.classList.remove('nav-open');
      var burgerEl = document.querySelector('.nav-burger');
      if (burgerEl) burgerEl.setAttribute('aria-expanded', 'false');
      /* Même remise à zéro des accordéons que assets/theme.js (closeSubs)
         pour que le tiroir se retrouve dans le même état, qu'il ait été
         refermé via la croix ou via l'ouverture d'une popup. */
      navMenu.querySelectorAll('.nav-dropdown-toggle.is-open').forEach(function (t) {
        t.classList.remove('is-open');
        var l = t.querySelector('.nav-link');
        if (l) l.setAttribute('aria-expanded', 'false');
      });
    }

    function open(p, trigger) {
      if (openPopup === p) return;
      if (openPopup) close(false);
      closeMobileDrawerIfOpen();
      lastFocus = trigger || document.activeElement;
      p.classList.add('is-open');
      p.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('booking-popup-open');
      openPopup = p;
      var target = p.querySelector('.booking-popup-close') || p;
      window.setTimeout(function () {
        try { target.focus({ preventScroll: true }); } catch (e) { target.focus(); }
      }, 40);
    }

    function close(restore) {
      if (!openPopup) return;
      var p = openPopup;
      p.classList.remove('is-open');
      p.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('booking-popup-open');
      openPopup = null;
      if (restore !== false && lastFocus && lastFocus.focus) {
        try { lastFocus.focus({ preventScroll: true }); } catch (e) {}
      }
    }

    document.querySelectorAll('[data-booking-popup]').forEach(function (p) {
      p.setAttribute('role', 'dialog');
      p.setAttribute('aria-modal', 'true');
      p.setAttribute('aria-hidden', 'true');
      if (!p.hasAttribute('tabindex')) p.setAttribute('tabindex', '-1');
      var title = p.querySelector('.booking-popup-title');
      if (title && !p.getAttribute('aria-labelledby')) {
        if (!title.id) title.id = 'booking-popup-title-' + p.getAttribute('data-booking-popup');
        p.setAttribute('aria-labelledby', title.id);
      }
      var x = p.querySelector('.booking-popup-close');
      if (x) {
        x.setAttribute('role', 'button');
        if (!x.getAttribute('aria-label')) x.setAttribute('aria-label', 'Fermer');
        if (!x.hasAttribute('tabindex')) x.setAttribute('tabindex', '0');
      }
    });

    document.querySelectorAll('[data-booking]').forEach(function (t) {
      if (findPopup(t.getAttribute('data-booking'))) t.setAttribute('aria-haspopup', 'dialog');
    });

    document.addEventListener('click', function (e) {
      var closer = e.target.closest('.booking-popup-close,.booking-popup-overlay');
      if (closer && openPopup && openPopup.contains(closer)) { e.preventDefault(); close(true); return; }
      var trig = e.target.closest('[data-booking]');
      if (!trig) return;
      var p = findPopup(trig.getAttribute('data-booking'));
      if (!p) { if ((trig.getAttribute('href') || '#') === '#') e.preventDefault(); return; }
      e.preventDefault();
      open(p, trig);
    });

    document.addEventListener('keydown', function (e) {
      if (!openPopup) return;
      if (e.key === 'Escape' || e.key === 'Esc') { e.preventDefault(); close(true); return; }
      if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
        var x = e.target.closest && e.target.closest('.booking-popup-close');
        if (x && openPopup.contains(x)) { e.preventDefault(); close(true); return; }
      }
      if (e.key === 'Tab') {
        var list = focusables(openPopup);
        if (!list.length) { e.preventDefault(); openPopup.focus(); return; }
        var first = list[0], last = list[list.length - 1];
        if (e.shiftKey && (document.activeElement === first || document.activeElement === openPopup)) {
          e.preventDefault(); last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault(); first.focus();
        }
      }
    });
  });

  /* --- b) Popup "film" : lecture/pause synchronisée à l'ouverture -------- */
  (function () {
    function go() {
      var popup = document.querySelector('[data-booking-popup="film"]');
      if (!popup) return;
      var video = popup.querySelector('.film-video');
      if (!video) return;
      video.setAttribute('controls', 'controls');
      video.setAttribute('playsinline', 'playsinline');
      var wasOpen = popup.classList.contains('is-open');
      new MutationObserver(function () {
        var isOpen = popup.classList.contains('is-open');
        if (isOpen === wasOpen) return;
        wasOpen = isOpen;
        if (isOpen) { var p = video.play(); if (p && p.catch) p.catch(function () {}); }
        else { video.pause(); video.currentTime = 0; }
      }).observe(popup, { attributes: true, attributeFilter: ['class'] });
    }
    if (document.readyState !== 'loading') go(); else document.addEventListener('DOMContentLoaded', go);
  })();

  /* --- c) Popup "teaser" : identique, mais FORCE le son ------------------ */
  (function () {
    function go() {
      var p = document.querySelector('[data-booking-popup="teaser"]');
      if (!p) return;
      var v = p.querySelector('.film-video');
      if (!v) return;
      v.setAttribute('controls', 'controls');
      v.setAttribute('playsinline', 'playsinline');
      v.controls = true; v.playsInline = true; v.muted = false; v.defaultMuted = false;
      v.removeAttribute('muted');
      var w = p.classList.contains('is-open');
      new MutationObserver(function () {
        var o = p.classList.contains('is-open');
        if (o === w) return;
        w = o;
        if (o) {
          v.muted = false; v.volume = 1;
          var q = v.play(); if (q && q.catch) q.catch(function () {});
        } else { v.pause(); v.currentTime = 0; }
      }).observe(p, { attributes: true, attributeFilter: ['class'] });
    }
    if (document.readyState !== 'loading') go(); else document.addEventListener('DOMContentLoaded', go);
  })();

  /* --- d) Popup "localisation" : carte Leaflet, auto-hébergée, paresseuse */
  (function () {
    function go() {
      var p = document.querySelector('[data-booking-popup="localisation"]');
      var el = p && p.querySelector('.nav-map');
      if (!el) return;

      var LAT = parseFloat(el.getAttribute('data-lat')) || 46.23156;
      var LNG = parseFloat(el.getAttribute('data-lng')) || 7.35818;
      var JS_URL = el.getAttribute('data-leaflet-js');
      var CSS_URL = el.getAttribute('data-leaflet-css');
      var map = null, loading = false, skinned = false;

      function skin() {
        if (skinned) return;
        skinned = true;
        var s = document.createElement('style');
        s.textContent =
          '.nav-map.leaflet-container{background:#1E2126;font:inherit}' +
          '.nav-map .leaflet-tile{filter:invert(1) hue-rotate(180deg) grayscale(.55) brightness(.78) contrast(1.05)}' +
          '.nav-map .oda-map-marker-wrap{background:none;border:none}' +
          '.nav-map .oda-map-marker{width:48px;height:48px;display:block;filter:drop-shadow(0 3px 6px rgba(0,0,0,.45))}' +
          '.nav-map .oda-map-attrib{position:absolute;right:6px;bottom:4px;z-index:1000;font-size:10px;color:#fff;opacity:.85;background:rgba(0,0,0,.55);padding:2px 5px;border-radius:2px;line-height:1.2;font-family:inherit}.nav-map .oda-map-attrib a{color:#fff;text-decoration:underline}' +
          '.nav-map .leaflet-control-zoom,.nav-map .leaflet-control-attribution{display:none}';
        (document.head || document.documentElement).appendChild(s);
      }

      function build() {
        if (map || !window.L) return;
        skin();
        map = L.map(el, {
          center: [LAT, LNG], zoom: 17,
          zoomControl: false, scrollWheelZoom: false, dragging: false, attributionControl: false
        });
        /* 02/09 : les fonds CARTO exigent désormais une clé (filigrane « API key
           required » sur chaque tuile). Fond OpenStreetMap standard, sans clé,
           passé en sombre par filtre CSS (inversion + rotation de teinte),
           cf. .nav-map .leaflet-tile dans skin(). */
        L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
          maxZoom: 19
        }).addTo(map);
        var attrib = document.createElement('div');
        attrib.className = 'oda-map-attrib';
        attrib.innerHTML = '&copy; <a href="https://www.openstreetmap.org/copyright" target="_blank" rel="noopener">OpenStreetMap</a> contributors';
        el.appendChild(attrib);
        L.marker([LAT, LNG], {
          icon: L.divIcon({
            className: 'oda-map-marker-wrap',
            html: '<div class="oda-map-marker"><svg viewBox="0 0 24 24" width="100%" height="100%"><path fill-rule="evenodd" fill="#d51919" d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zM12 11.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/></svg></div>',
            iconSize: [48, 48], iconAnchor: [24, 45]
          })
        }).addTo(map);
        window.setTimeout(function () {
          if (map) { map.invalidateSize(); map.setView([LAT, LNG], 17); }
        }, 50);
      }

      function show() {
        if (window.L) { build(); return; }
        if (loading || !JS_URL) return;
        loading = true;
        if (CSS_URL && !document.querySelector('link[href="' + CSS_URL + '"]')) {
          var l = document.createElement('link');
          l.rel = 'stylesheet'; l.href = CSS_URL;
          (document.head || document.documentElement).appendChild(l);
        }
        var s = document.createElement('script');
        s.src = JS_URL; s.onload = build;
        (document.head || document.documentElement).appendChild(s);
      }

      var wasOpen = p.classList.contains('is-open');
      new MutationObserver(function () {
        var isOpen = p.classList.contains('is-open');
        if (isOpen === wasOpen) return;
        wasOpen = isOpen;
        if (isOpen) show();
      }).observe(p, { attributes: true, attributeFilter: ['class'] });
    }
    if (document.readyState !== 'loading') go(); else document.addEventListener('DOMContentLoaded', go);
  })();

  /* --- f) Onglets de planning, .planning-tabs (04/09, généralisé 05/09) --
     Onglets créés par snippets/oda-planning-widget.liquid : un groupe
     .planning-tabs (même langage visuel que la popup "Planning" de la
     navbar, CSS non redéclaré, cf. sections/global-popups.liquid)
     au-dessus d'un conteneur [data-sportigo-planning]. Moteur GÉNÉRIQUE,
     un seul pour DEUX contextes :
       - DANS une popup [data-booking-popup] (zone Combat/HYROX/Hybrid 360/
         Calisthenics/Préparation physique, ET depuis le 05/09 la popup
         "Planning" de la navbar elle-même, qui utilisait avant un markup
         et un script dédiés dupliqués ici) : montage à l'OUVERTURE, onglet
         préselectionnable via [data-booking][data-booking-tab], option
         data-planning-reset-on-close (posée UNIQUEMENT par la popup
         navbar, cf. son commentaire dans oda-planning-widget.liquid) pour
         revenir sur le 1er onglet à la FERMETURE.
       - EN LIGNE dans une section de page normale (05/09, plannings
         intégrés : sections/home-planning.liquid + le bloc #planning des
         pages de zone) : montage au CHARGEMENT de la page, 1er onglet
         ("Tout"/"Tous", déjà .is-active dans le HTML rendu par le
         snippet) actif par défaut, jamais de réinitialisation puisqu'il
         n'y a pas de fermeture.
     Pas d'onglets configurés pour une zone (HYROX, Hybrid 360,
     Calisthenics, Préparation physique tant qu'aucun onglet n'y est
     ajouté, cf. demande Yann) => pas de .planning-tabs dans le DOM => cette
     fonction ne fait rien, le planning se comporte comme un planning
     simple (comme fighter-lab-planning/recovery-planning côté popup).

     Ouverture sur un onglet précis ("Découvrir le MMA" doit ouvrir le
     planning de la zone Combat directement sur l'onglet MMA) : un
     déclencheur [data-booking][data-booking-tab="xxx"] mémorise l'onglet
     demandé AU CLIC, sur le MÊME évènement click que celui qui ouvre la
     popup (moteur générique (a) plus haut) ; à l'ouverture, la popup monte
     directement sur cet onglet au lieu de "Tous". Pas de double montage :
     le montage automatique de assets/sportigo-planning.js (son scan() se
     redéclenche 250 ms après CHAQUE clic) est devancé par le remount()
     synchrone déclenché par le MutationObserver ci-dessous, les callbacks
     MutationObserver passent toujours avant le moindre setTimeout (file de
     micro-tâches JS vidée avant la file de macro-tâches), quel que soit
     l'ordre d'enregistrement des écouteurs 'click' entre ce fichier et le
     moteur générique (a).

     Fermeture : AUCUN remontage forcé par défaut (une popup de zone rouvre
     toujours là où on lui redemande d'ouvrir, elle ne "réinitialise"
     jamais toute seule) ; SAUF si .planning-tabs porte
     data-planning-reset-on-close (popup "Planning" navbar uniquement),
     auquel cas elle revient sur le 1er onglet à la fermeture, comportement
     historique de cette popup conservé tel quel. Onglet déjà affiché : pas
     de remontage inutile (comparaison `tab !== current`), affichage
     instantané du contenu déjà chargé. */
  (function () {
    /* REPRISE LOT D2 BIS (05/09, controleur independant, defaut 4) : le
       fondu de bord (CSS, sections/global-popups.liquid, .planning-tabs)
       est STATIQUE par defaut (fondu des 2 cotes en permanence, meme une
       fois defile jusqu'au bout ou tout au debut) -- classes is-at-start/
       is-at-end posees ici pour ne fondre QUE le cote ou il reste
       reellement du contenu a decouvrir (jamais de coupe nette). Un seul
       mecanisme, partage par TOUTE .planning-tabs du site (popups ET
       plannings integres, meme logique que wireTabs() ci-dessous). */
    function updateEdgeFade(tabs) {
      var atStart = tabs.scrollLeft <= 1;
      var atEnd = tabs.scrollLeft + tabs.clientWidth >= tabs.scrollWidth - 1;
      tabs.classList.toggle('is-at-start', atStart);
      tabs.classList.toggle('is-at-end', atEnd);
    }

    /* wireTabs() : cœur commun clic/clavier/remontage, partagé par les
       deux contextes (popup et en ligne) ci-dessous. Retourne null si déjà
       câblé ou si le mount est introuvable (rien à faire). */
    function wireTabs(tabs, mountEl) {
      if (tabs.__odaWired) return null;
      tabs.__odaWired = true;
      var buttons = [].slice.call(tabs.querySelectorAll('.planning-tab'));
      var defaultBtn = tabs.querySelector('.planning-tab.is-active') || buttons[0];
      var current = null;

      updateEdgeFade(tabs);
      tabs.addEventListener('scroll', function () { updateEdgeFade(tabs); }, { passive: true });

      function activate(btn) {
        buttons.forEach(function (b) {
          var on = b === btn;
          b.classList.toggle('is-active', on);
          b.setAttribute('aria-selected', on ? 'true' : 'false');
          b.setAttribute('tabindex', on ? '0' : '-1');
        });
        var tab = btn.getAttribute('data-planning-tab');
        var changed = tab !== current;
        current = tab;
        if (changed && window.OdaSportigoPlanning && window.OdaSportigoPlanning.remount) {
          /* 07/09 (plannings par ZONE) : un onglet filtre soit par ACTIVITES
             (data-activities, format historique "Libelle | 7460, 7459"), soit
             par PLANNING Sportigo dedie (data-planning, nouveau format
             "Libelle | planning:4463", cf. snippets/oda-planning-widget.liquid).
             Les deux attributs sont transmis tels quels : un onglet par
             activites ne porte pas data-planning, getAttribute renvoie null et
             remount() retire alors l'attribut du point de montage, soit
             exactement le comportement d'avant ce lot. */
          window.OdaSportigoPlanning.remount(mountEl, btn.getAttribute('data-activities'), btn.getAttribute('data-planning'));
          if (window.OdaPlanningLoading) window.OdaPlanningLoading.rearm(mountEl);
        }
      }

      tabs.addEventListener('click', function (e) {
        var btn = e.target.closest('.planning-tab');
        if (btn) activate(btn);
      });
      /* Navigation clavier gauche/droite (tablist horizontale, roving
         tabindex déjà posé par activate() ci-dessus). */
      tabs.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        var i = buttons.indexOf(document.activeElement);
        if (i === -1) return;
        e.preventDefault();
        var next = buttons[(i + (e.key === 'ArrowRight' ? 1 : buttons.length - 1) + buttons.length) % buttons.length];
        next.focus();
        activate(next);
      });

      return { buttons: buttons, defaultBtn: defaultBtn, activate: activate };
    }

    /* --- Onglets DANS une popup : montage à l'ouverture, préselection,
       reset optionnel à la fermeture. --- */
    var pendingTab = null;
    document.addEventListener('click', function (e) {
      var trig = e.target.closest && e.target.closest('[data-booking][data-booking-tab]');
      pendingTab = trig ? { popup: trig.getAttribute('data-booking'), tab: trig.getAttribute('data-booking-tab') } : null;
    });

    function wirePopup(popup) {
      var tabs = popup.querySelector('.planning-tabs');
      var mountEl = popup.querySelector('[data-sportigo-planning]');
      if (!tabs || !mountEl) return;
      var api = wireTabs(tabs, mountEl);
      if (!api) return;
      var resetOnClose = tabs.hasAttribute('data-planning-reset-on-close');

      var wasOpen = popup.classList.contains('is-open');
      new MutationObserver(function () {
        var isOpen = popup.classList.contains('is-open');
        if (isOpen === wasOpen) return;
        wasOpen = isOpen;
        if (isOpen) {
          var id = popup.getAttribute('data-booking-popup');
          var want = api.defaultBtn;
          if (pendingTab && pendingTab.popup === id) {
            var found = api.buttons.filter(function (b) { return b.getAttribute('data-planning-tab') === pendingTab.tab; })[0];
            if (found) want = found;
          }
          if (want) api.activate(want);
          /* La rangee passe de display:none a flex a l'ouverture :
             scrollWidth/clientWidth ne sont fiables qu'une fois le layout
             pose, cf. la garde des popups Sportigo plus haut. */
          window.requestAnimationFrame(function () { updateEdgeFade(tabs); });
        } else if (resetOnClose && api.defaultBtn) {
          api.activate(api.defaultBtn);
        }
      }).observe(popup, { attributes: true, attributeFilter: ['class'] });
    }

    /* --- Onglets EN LIGNE (hors popup) : montage direct au chargement,
       1er bouton (déjà .is-active dans le HTML) actif par défaut. --- */
    function wireInline(tabs) {
      if (tabs.closest('[data-booking-popup]')) return; // géré par wirePopup ci-dessus
      var mountEl = tabs.parentElement && tabs.parentElement.querySelector('[data-sportigo-planning]');
      if (!mountEl) return;
      wireTabs(tabs, mountEl);
    }

    function scan() {
      [].slice.call(document.querySelectorAll('[data-booking-popup]')).forEach(wirePopup);
      [].slice.call(document.querySelectorAll('.planning-tabs')).forEach(wireInline);
    }
    if (document.readyState !== 'loading') scan(); else document.addEventListener('DOMContentLoaded', scan);
  })();

  /* --- g) Indicateur de chargement générique du widget Sportigo (05/09,
     revue Opus 04/09 : "cadre pointillé vide" pendant 3-4s au montage,
     retour Murat) -----------------------------------------------------
     Injecte un petit indicateur "Chargement du planning…" + spinner CSS
     (styles : sections/global-popups.liquid, .planning-loading) au-dessus
     de CHAQUE point de montage [data-sportigo-planning] du site (popups ET
     plannings intégrés, un seul mécanisme, aucune modification de
     assets/sportigo-planning.js : on observe le mount depuis l'extérieur).
     Masqué dès que le widget a rendu du contenu réel dans son shadow DOM
     (détection GÉNÉRIQUE : au moins un enfant du shadowRoot autre que le
     <style> que assets/sportigo-planning.js y injecte lui-même : fonctionne
     aussi bien pour AppointmentFull, historiquement le seul type de mount
     visé ici, que pour BuyFromList qui n'a pas les mêmes classes
     internes). Ré-armé explicitement par wireTabs() ci-dessus (fonction
     rearm) juste après chaque remount() de changement d'onglet : le mount
     est vidé de façon SYNCHRONE par sportigo-planning.js (demonter() fait
     el.innerHTML = '' avant de relancer le montage), l'appeler juste après
     remount() garantit donc que firstElementChild est déjà redevenu null
     au moment où rearm() s'exécute. */
  (function () {
    function ensureIndicator(mountEl) {
      var host = mountEl.parentElement;
      if (!host) return null;
      var existing = host.querySelector(':scope > .planning-loading');
      if (existing) return existing;
      if (window.getComputedStyle(host).position === 'static') host.style.position = 'relative';
      var ind = document.createElement('div');
      ind.className = 'planning-loading';
      ind.setAttribute('aria-hidden', 'true');
      var spinner = document.createElement('span');
      spinner.className = 'planning-loading-spinner';
      var text = document.createElement('span');
      text.className = 'planning-loading-text';
      text.textContent = 'Chargement du planning…';
      ind.appendChild(spinner);
      ind.appendChild(text);
      host.insertBefore(ind, mountEl.nextSibling);
      return ind;
    }

    function hasContent(mountEl) {
      var host = mountEl.firstElementChild;
      var sr = host && host.shadowRoot;
      if (!sr) return false;
      for (var i = 0; i < sr.children.length; i++) {
        var tag = sr.children[i].tagName;
        if (tag !== 'STYLE' && tag !== 'LINK') return true;
      }
      return false;
    }

    function poll(mountEl, ind) {
      var tries = 0;
      var timer = window.setInterval(function () {
        tries++;
        if (hasContent(mountEl)) { ind.classList.add('is-hidden'); window.clearInterval(timer); return; }
        if (tries > 100) window.clearInterval(timer); // ~15s : abandon silencieux, le texte reste affiché (pas pire qu'avant)
      }, 150);
    }

    function watch(mountEl) {
      if (mountEl.__odaLoadingWatch) return;
      mountEl.__odaLoadingWatch = true;
      var ind = ensureIndicator(mountEl);
      if (!ind) return;
      if (mountEl.firstElementChild) { poll(mountEl, ind); return; }
      /* Mount pas encore lancé (popup fermée, cf. assets/sportigo-planning.js
         qui ne monte que les conteneurs visibles) : on attend, sans coût,
         que sportigo-planning.js y ajoute son hôte (à l'ouverture), quel
         que soit le délai avant cette ouverture. */
      var mo = new MutationObserver(function () {
        if (mountEl.firstElementChild) { mo.disconnect(); poll(mountEl, ind); }
      });
      mo.observe(mountEl, { childList: true });
    }

    function rearm(mountEl) {
      var host = mountEl.parentElement;
      var ind = host && host.querySelector(':scope > .planning-loading');
      if (ind) ind.classList.remove('is-hidden');
      mountEl.__odaLoadingWatch = false;
      watch(mountEl);
    }

    window.OdaPlanningLoading = { watch: watch, rearm: rearm };

    function scan() {
      [].slice.call(document.querySelectorAll('[data-sportigo-planning]')).forEach(watch);
    }
    if (document.readyState !== 'loading') scan(); else document.addEventListener('DOMContentLoaded', scan);
    /* Mêmes déclencheurs que le scan() de assets/sportigo-planning.js
       (250 ms après chaque clic) : capte les mounts qui viennent
       d'apparaître dans le DOM (ouverture de popup). */
    document.addEventListener('click', function () { window.setTimeout(scan, 250); });
  })();
})();

